const e = "더 큰 숫자 입력", n = "더 작은 숫자 입력", t = {
  increment: e,
  decrement: n
};
export {
  n as decrement,
  t as default,
  e as increment
};
